export const FR_LANG = 'fr-FR';
export const EN_LANG = 'en';
